// src/config/serverConfig.js

const serverConfig = {
  activeServers: {
    S1: true,
    S2: true,
    S3: true,
    Imdb: true,
    Tmdb: true,
  },
  serverGroups: {
    Download: ['S1', 'S2', 'S3'],
    Stream: ['Imdb', 'Tmdb'],
    Discover: ['Imdb'], // Only 'Imdb' is needed for 'Discover'
  },
};

export default serverConfig;
